import * as THREE from 'three';
import React, { useMemo } from 'react';
import { correctAxisData, loadTexture } from '../../utils';
import * as constantsViewer from '../../constants';
import textureSlat from 'assets/images/textures/whiteash.jpg';
import data from './data/drawerHandle';

export function DrawerButton({
  drawerHandle = null,
  cabinetWidth = 1000,
  cabinetDepth = 420,
  bPosition = 'C',
  unselected = false,
}) {
  var modelCabinetWidth = 999;
  var xOffset = 185;

  var modelCabinetDepth = 419;

  var scaleZ = cabinetDepth / modelCabinetDepth;

  var cabinetDiffWith = cabinetWidth - modelCabinetWidth;
  var cabinetDiffDepth = cabinetDepth - modelCabinetDepth;

  var vertices = new Float32Array(data.drawerButton.vertices);
  var normals = new Float32Array(data.drawerButton.normals);

  return (
    <mesh
      receiveShadow
      castShadow
      renderOrder={constantsViewer.ZORDER_HANDLE}
      onUpdate={self => {
        var center = new THREE.Vector3();
        self.geometry.computeBoundingBox();
        self.geometry.boundingBox.getCenter(center);
        self.geometry.center();
        self.position.copy(center);
        let size = new THREE.Vector3();
        self.geometry.boundingBox.getSize(size);

        switch (bPosition) {
          case 'FL':
            self.position.x -= cabinetDiffWith / 2;
            self.position.z += cabinetDiffDepth / 2;
            break;

          case 'FR':
            self.position.x +=
              modelCabinetWidth + cabinetDiffWith / 2 - 10 - size.x;
            self.position.z += cabinetDiffDepth / 2;
            self.position.x -= 2 * xOffset;
            break;

          case 'C':
            self.position.x -= cabinetDiffWith / 2;
            self.position.z += cabinetDiffDepth / 2;
            self.position.x -= xOffset;
            self.position.x += cabinetWidth / 2;

            break;

          default:
            break;
        }
      }}
      /*rotation={[Math.PI / 2, 0, 0]}
          scale={[1,1.5,1]}
          position={[1,300,1]}*/
    >
      <bufferGeometry attach="geometry">
        <bufferAttribute
          attachObject={['attributes', 'position']}
          count={vertices.length / 3}
          array={correctAxisData(vertices)}
          itemSize={3}
        />
        <bufferAttribute
          attachObject={['attributes', 'normal']}
          count={normals.length / 3}
          array={correctAxisData(normals)}
          itemSize={3}
        />
      </bufferGeometry>
      <meshPhongMaterial
        attach="material"
        color={drawerHandle.color.hexaNum}
        specular={0x919191}
        shininess={4.92458}
        opacity={unselected ? constantsViewer.OPACITY_UNSELECTED_SHELF : 1}
        transparent
      />
    </mesh>
  );
}

export function DrawerClassicHandle({
  drawerHandle = null,
  cabinetWidth = 1000,
  cabinetDepth = 420,
  bPosition = 'C',
  unselected = false,
}) {
  var modelCabinetWidth = 999;
  var xOffset = 205;

  var modelCabinetDepth = 419;

  var scaleZ = cabinetDepth / modelCabinetDepth;

  var cabinetDiffWith = cabinetWidth - modelCabinetWidth;
  var cabinetDiffDepth = cabinetDepth - modelCabinetDepth;

  var vertices = new Float32Array(data.drawerClassicHandle.vertices);
  var normals = new Float32Array(data.drawerClassicHandle.normals);

  return (
    <mesh
      receiveShadow
      castShadow
      renderOrder={constantsViewer.ZORDER_HANDLE}
      onUpdate={self => {
        var center = new THREE.Vector3();
        self.geometry.computeBoundingBox();
        self.geometry.boundingBox.getCenter(center);
        self.geometry.center();
        self.position.copy(center);
        let size = new THREE.Vector3();
        self.geometry.boundingBox.getSize(size);

        switch (bPosition) {
          case 'FL':
            self.position.x -= cabinetDiffWith / 2;
            self.position.z += cabinetDiffDepth / 2;

            break;

          case 'FR':
            self.position.x += modelCabinetWidth + cabinetDiffWith / 2;
            self.position.z += cabinetDiffDepth / 2;
            self.position.x -= 2 * xOffset;
            break;

          case 'C':
            self.position.x -= cabinetDiffWith / 2;
            self.position.z += cabinetDiffDepth / 2;
            self.position.x -= xOffset;
            self.position.x += cabinetWidth / 2;

            break;

          default:
            break;
        }
      }}
      /*rotation={[Math.PI / 2, 0, 0]}
          scale={[1,1.5,1]}
          position={[1,300,1]}*/
    >
      <bufferGeometry attach="geometry">
        <bufferAttribute
          attachObject={['attributes', 'position']}
          count={vertices.length / 3}
          array={correctAxisData(vertices)}
          itemSize={3}
        />
        <bufferAttribute
          attachObject={['attributes', 'normal']}
          count={normals.length / 3}
          array={correctAxisData(normals)}
          itemSize={3}
        />
      </bufferGeometry>
      <meshPhongMaterial
        attach="material"
        color={drawerHandle.color.hexaNum}
        specular={0x919191}
        shininess={4.92458}
        opacity={unselected ? constantsViewer.OPACITY_UNSELECTED_SHELF : 1}
        transparent
      />
    </mesh>
  );
}

export function DrawerSlat({
  drawerHeight = 370,
  cabinetWidth = 1000,
  cabinetDepth = 420,
  unselected = false,
}) {
  var modelCabinetWidth = 999;
  var modelCabinetDepth = 419;
  var modelDrawerHeight = 370;

  var scaleX = cabinetWidth / modelCabinetWidth;
  var posYDiff = modelDrawerHeight - drawerHeight;

  scaleX = (modelCabinetWidth * scaleX - 55) / 950;
  var scaleZ = cabinetDepth / modelCabinetDepth;

  var cabinetDiffWith = cabinetWidth - modelCabinetWidth;
  var cabinetDiffDepth = cabinetDepth - modelCabinetDepth;

  var vertices = new Float32Array(data.drawerSlat.vertices);
  var normals = new Float32Array(data.drawerSlat.normals);
  var uv_coord = new Float32Array(data.drawerSlat.uv_coord);

  const texture = useMemo(() => loadTexture(textureSlat), [textureSlat]);

  return (
    <mesh
      receiveShadow
      castShadow
      renderOrder={constantsViewer.ZORDER_HANDLE}
      onUpdate={self => {
        var center = new THREE.Vector3();
        self.geometry.computeBoundingBox();
        self.geometry.boundingBox.getCenter(center);
        self.geometry.center();
        self.position.copy(center);
        self.geometry.scale(scaleX, 1, 1);
        self.position.x -= 2;
        self.position.z += cabinetDiffDepth / 2;
        self.position.y -= posYDiff / 2;
      }}
      /*rotation={[Math.PI / 2, 0, 0]}
          scale={[1,1.5,1]}
          position={[1,300,1]}*/
    >
      <bufferGeometry attach="geometry">
        <bufferAttribute
          attachObject={['attributes', 'position']}
          count={vertices.length / 3}
          array={correctAxisData(vertices)}
          itemSize={3}
        />
        <bufferAttribute
          attachObject={['attributes', 'normal']}
          count={normals.length / 3}
          array={correctAxisData(normals)}
          itemSize={3}
        />
        <bufferAttribute
          attachObject={['attributes', 'uv']}
          count={uv_coord.length / 2}
          array={uv_coord}
          itemSize={2}
        />
      </bufferGeometry>
      <meshPhongMaterial
        attach="material"
        color={constantsViewer.MATERIAL_CROSSPIECE_COLOR}
        specular={constantsViewer.MATERIAL_CROSSPIECE_SPECULAR}
        shininess={constantsViewer.MATERIAL_CROSSPIECE_SHININESS}
        opacity={unselected ? constantsViewer.OPACITY_UNSELECTED_SHELF : 1}
        transparent
        map={texture}
      />
    </mesh>
  );
}
